export type DesktopAnalyticsContext = Readonly<{
  client: 'padlet_desktop'
  appVersion: string
  buildVersion: string | null
  distribution: 'mas' | 'developer_id' | 'unpackaged'
  environment: 'production' | 'development'
}>

export function parseDesktopAnalyticsContext(value: unknown): DesktopAnalyticsContext | undefined {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return
  const { client, appVersion, buildVersion, distribution, environment } = value as Record<string, unknown>
  if (
    client !== 'padlet_desktop' ||
    typeof appVersion !== 'string' ||
    !/^\d+\.\d+\.\d+(?:-[\w.-]+)?$/.test(appVersion) ||
    appVersion.length > 64
  )
    return
  if (
    buildVersion !== null &&
    (typeof buildVersion !== 'string' || !/^\d+(?:\.\d+)*$/.test(buildVersion) || buildVersion.length > 64)
  )
    return
  if (distribution !== 'mas' && distribution !== 'developer_id' && distribution !== 'unpackaged') return
  if (environment !== 'production' && environment !== 'development') return
  if (distribution === 'unpackaged' && environment !== 'development') return
  return Object.freeze({
    client,
    appVersion,
    buildVersion: typeof buildVersion === 'string' ? buildVersion : null,
    distribution,
    environment,
  })
}
